module.exports = __webpack_public_path__ + "../../../static/img/bs_ic_04.5edc3781.png";